// Utility functions for saving wallet milestone logic

export const MILESTONES = [250000, 500000, 750000, 1000000];

/**
 * Check if user has achieved a new milestone
 * @param previousPoints - Points before the update
 * @param currentPoints - Current points after update
 * @returns The milestone achieved, or null if none
 */
export const checkMilestoneAchievement = (
  previousPoints: number,
  currentPoints: number
): number | null => {
  return MILESTONES.find(milestone => 
    previousPoints < milestone && currentPoints >= milestone
  ) || null;
};

/**
 * Get the next milestone target for a given points amount
 * @param currentPoints - Current points
 * @returns The next milestone target, or null if all milestones achieved
 */
export const getNextMilestone = (currentPoints: number): number | null => {
  return MILESTONES.find(milestone => currentPoints < milestone) || null;
};

/**
 * Calculate progress percentage to next milestone
 * @param currentPoints - Current points
 * @returns Progress percentage (0-100)
 */
export const getMilestoneProgress = (currentPoints: number): number => {
  const nextMilestone = getNextMilestone(currentPoints);
  if (!nextMilestone) return 100; // All milestones achieved
  
  const previousMilestoneIndex = MILESTONES.indexOf(nextMilestone) - 1;
  const previousMilestone = previousMilestoneIndex >= 0 ? MILESTONES[previousMilestoneIndex] : 0;
  
  return ((currentPoints - previousMilestone) / (nextMilestone - previousMilestone)) * 100;
};